"use strict";
/**
 * @file Created on 20.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");

var NSimulationProductDTO_1 = require("./NSimulationProductDTO");

var NSimulationWindowDTO_1 = require("./NSimulationWindowDTO");
/**
 * @author Tomas Leity
 */


var NSimulationDTO =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NSimulationDTO, _NotificationDoc_1$No);

  /**
   * @param window
   * @param products
   */
  function NSimulationDTO(window, products) {
    var _this;

    _classCallCheck(this, NSimulationDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NSimulationDTO).call(this));
    _this.window = window;
    _this.products = products;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NSimulationDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NSimulationDTO(mat.window, mat.products);
    }
  }]);

  return NSimulationDTO;
}(NotificationDoc_1.NotificationDoc);

exports.NSimulationDTO = NSimulationDTO;

NSimulationDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NSimulationDTO.name);
  return {
    window: builder.obj('window', NSimulationWindowDTO_1.NSimulationWindowDTO.schema, function (mat) {
      return NSimulationWindowDTO_1.NSimulationWindowDTO.fromDataDict(mat);
    }),
    products: builder.listOf(builder.obj('products', NSimulationProductDTO_1.NSimulationProductDTO.schema, function (mat) {
      return NSimulationProductDTO_1.NSimulationProductDTO.fromDataDict(mat);
    }))
  };
}();